import { gql, useQuery } from '@apollo/client';

import BaseObligationsTable from './BaseObligationsTable';
import { ObligationsDateFormat } from './BaseObligationsTable';

import type {
  GetOverdueObligationsForUserQuery,
  GetOverdueObligationsForUserQueryVariables,
} from './__generated__/OverdueObligationsTable.gql';
import type { IDateStatus, IObligationsTableRowData } from './BaseObligationsTable';

const GET_OVERDUE_OBLIGATIONS_FOR_USER = gql`
  query GetOverdueObligationsForUser {
    getOverdueObligationsForUser {
      ...ObligationsTableRow
    }
  }
  ${BaseObligationsTable.Fragment}
`;

const getOverdueDateStatus = (row: IObligationsTableRowData): IDateStatus => ({
  label: row.entityType === 'RecurringTransaction' ? 'Not received yet' : 'Overdue',
  className: 'text-error-primary',
});

const OverdueObligationsTable = () => {
  const { data, loading, error } = useQuery<
    GetOverdueObligationsForUserQuery,
    GetOverdueObligationsForUserQueryVariables
  >(GET_OVERDUE_OBLIGATIONS_FOR_USER);

  const rows = data?.getOverdueObligationsForUser ?? [];

  return (
    <BaseObligationsTable
      title="Overdue"
      rows={rows}
      dateFormat={ObligationsDateFormat.Relative}
      getDateStatus={getOverdueDateStatus}
      emptyStateMessage="No overdue bills or subscriptions"
      showChargeSummary={true}
      isLoading={loading}
      hasError={Boolean(error)}
    />
  );
};

export default OverdueObligationsTable;
